import { Menu, MenuGroup, MenuButton, MenuList, MenuItem, useToast } from "@chakra-ui/react";
import { AccountIcon } from "lib/icons/account";
import { CardIcon } from "lib/icons/cardIcon";
import { HelpIcon } from "lib/icons/help";
import { LogOutIcon } from "lib/icons/logout";
import { TeamIcon } from "lib/icons/team";
import { logoutClient } from "lib/clients";
import getConfig from 'next/config';
import { useRouter } from "next/router";
import { atLeastAdmin, isPreviewingPack } from "lib/utils";
import { AccessHandler, MeAvatar } from "components";
import { IoExtensionPuzzleOutline } from '@react-icons/all-files/io5/IoExtensionPuzzleOutline';
import { useLoggedinUser } from "lib/hooks";

const { publicRuntimeConfig: { genericSubDomain, baseProtocol, baseDomain, basePort }} = getConfig();

export const UserMenu = () => {
  const { data: user, isLoggedIn } = useLoggedinUser();
  const { push } = useRouter()
  const toast = useToast();
  const { pathname } = useRouter();
  
  const isPreviewing = isPreviewingPack(pathname);

  if (!isLoggedIn || isPreviewing) {
    return null;
  }

  const logout = async () => {
    try {
      await logoutClient.logout();
      window.location.href = `${baseProtocol}://${genericSubDomain}${baseDomain}${basePort}/login`;
    }
    catch(e) {
      toast({
        title: 'Log out failed',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      });
    }
  }

  return (
    <Menu>
      <MenuButton data-testid={"user-menu"}>
        <MeAvatar showProgress={false} />
      </MenuButton>
      <MenuList>
        <MenuGroup title={`${user?.first_name} ${user?.last_name}`}>
          <MenuItem icon={<AccountIcon boxSize="14px" />} onClick={() => push('/account/edit-profile')}>Edit profile</MenuItem>
          <MenuItem icon={<AccountIcon boxSize="14px" />} onClick={() => push('/account/edit-bio')}>Edit bio card</MenuItem>
          <AccessHandler allowedRoles={atLeastAdmin}><MenuItem icon={<CardIcon boxSize="14px" />} onClick={() => push('/account/billing')}>Billing &amp; invoices</MenuItem></AccessHandler>
          <MenuItem icon={<TeamIcon boxSize="14px" />} onClick={() => push('/account/team')}>My team</MenuItem>
          <MenuItem icon={<IoExtensionPuzzleOutline size="14px" />} onClick={() => push('/account/add-ons')}>Add-ons</MenuItem>
          <MenuItem icon={<HelpIcon boxSize="14px" />} onClick={() => window.open('https://knowledge-base.packs.co/packs/xfd93c57a-483f-4019-beae-5e89e1c6bcdf', '_blank')}>Knowledge base</MenuItem>
          <MenuItem icon={<LogOutIcon boxSize="14px" />} onClick={logout} data-testid={"sign-out"}>Sign out</MenuItem>
        </MenuGroup>
      </MenuList>
    </Menu>
  )
};
